/**
 * Rental photo gallery ordering.
 *
 * The server renders ordering capability on the grid itself. This keeps the
 * client side inert for filtered galleries and photo types that have no order
 * field, while the backend remains the source of truth for the final order.
 */
import Sortable from 'sortablejs';

(function () {
    'use strict';

    var SORTABLE_SELECTOR = '[data-rental-photo-sort]';

    function photoItems(grid) {
        return Array.from(grid.querySelectorAll(':scope > [data-photo-id]'));
    }

    function restoreItems(grid, items) {
        items.forEach(function (item) {
            if (item.parentNode === grid) grid.appendChild(item);
        });
    }

    function initGrid(grid) {
        if (!grid || grid._rentalPhotoSortable) return;

        var sortUrl = grid.getAttribute('data-rental-photo-sort');
        var target = grid.getAttribute('data-rental-photo-target');
        if (!sortUrl || !target || !grid.querySelector('[data-photo-drag-handle]')) return;

        var originalItems = null;
        grid._rentalPhotoSortable = Sortable.create(grid, {
            draggable: '[data-photo-id]',
            handle: '[data-photo-drag-handle]',
            animation: 150,
            onStart: function () {
                originalItems = photoItems(grid);
            },
            onEnd: function (event) {
                if (event.oldIndex === event.newIndex) return;

                // The gallery only becomes authoritative after the server saves
                // the order. Restore it immediately so a rejected request never
                // leaves a visually unsaved arrangement on screen.
                restoreItems(grid, originalItems || []);
                grid._rentalPhotoSortable.option('disabled', true);

                window.htmx.ajax('POST', sortUrl, {
                    source: grid,
                    target: target,
                    swap: 'outerHTML',
                    values: {
                        photo_id: event.item.getAttribute('data-photo-id'),
                        to_index: event.newIndex,
                    },
                }).then(function () {
                    if (grid.isConnected && grid._rentalPhotoSortable) {
                        grid._rentalPhotoSortable.option('disabled', false);
                    }
                    scan(document);
                }, function () {
                    if (grid.isConnected && grid._rentalPhotoSortable) {
                        grid._rentalPhotoSortable.option('disabled', false);
                    }
                    if (window.SeeMe && window.SeeMe.toast) {
                        window.SeeMe.toast.error('Could not save photo order. Please try again.');
                    }
                });
            },
        });
    }

    function scan(root) {
        var scope = root || document;
        if (scope.querySelectorAll) scope.querySelectorAll(SORTABLE_SELECTOR).forEach(initGrid);
        if (scope.matches && scope.matches(SORTABLE_SELECTOR)) initGrid(scope);
    }

    window._cc = window._cc || {};
    window._cc.initRentalPhotoSorting = scan;

    // SeeMe's lightbox opens from a document-level click handler. A handle is
    // an ordering control, so consume its click before it reaches the viewer.
    document.addEventListener('click', function (event) {
        if (!event.target.closest('[data-photo-drag-handle]')) return;
        event.preventDefault();
        event.stopPropagation();
    }, true);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
    else scan();
    document.body.addEventListener('htmx:afterSwap', function (event) { scan(event.detail.elt || document); });
})();
